import { APIError } from '@beable/mwm-commons-endpoint-client';
import Result from 'true-myth/result';
import RosterBackendService from './RosterBackendService';
  
async function getContests() {
    const response = await RosterBackendService.getContests();
    if (response.isOk()) {
        return response.value;
    }

    return null;
}

async function uploadContestZip(file: File, contestId?: string): Promise<Result<boolean, APIError<string>>> {
    const response = await RosterBackendService.uploadContestZip({ fileName: file.name, contestId });
    return response;
}

export default {
    getContests, uploadContestZip
}
